import React from 'react';

import { DODGER_BLUE, WHITE } from '@constant/colors';

const Interactive = () => (
  <svg viewBox="0 0 70 45">
    <g fill="none" fillRule="evenodd">
      <rect fill={DODGER_BLUE} width="70" height="45" rx="5" />
      <circle fill={WHITE} opacity=".2" cx="27" cy="22" r="10" />
      <circle fill={WHITE} opacity=".4" cx="35" cy="22" r="10" />
      <circle fill={WHITE} cx="42" cy="22" r="10" />
    </g>
  </svg>
);

export default Interactive;
